import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import subgroup from "./subgroup";
import { config as defaultConfig } from '@/views/visual/dataScreen/js/option/config';
import { getObj } from '@/api/visual/visual'; // import { getObj } from '@/api/visual/visual'

import Vue from 'vue';
Vue.prototype.$website = window.$website;
export default {
  name: 'contents',
  inject: ["contain"],
  props: {
    option: Object,
    id: [String, Number],
    wscale: Number
  },
  provide: function provide() {
    return {
      contain: this.contain,
      container: this
    };
  },
  components: {
    subgroup: subgroup
  },
  data: function data() {
    return {
      contentStyle: {},
      selectCount: {
        x1: null,
        x2: null,
        y1: null,
        y2: null
      },
      scale: 1,
      gradeFlag: false
    };
  },
  computed: {
    stepScale: function stepScale() {
      var scale = Number(100 / (this.scale * this.wscale)).toFixed(2);
      return scale;
    },
    //计算中央可视化大屏比例
    styleName: function styleName() {
      var _this = this;

      var scale = this.contain.config.scale;
      var widthVal = scale / 100 + 0.001;
      var heightVal = document.body.clientHeight / this.contain.config.height - 0.002;
      return Object.assign({
        transform: "scale(".concat(widthVal, ", ").concat(widthVal, ")"),
        width: this.setPx(this.contain.config.width),
        height: this.setPx(this.contain.config.height),
        backgroundColor: this.contain.config.backgroundColor
      }, function () {
        if (_this.contain.config.backgroundImage) {
          return {
            background: "url(".concat(_this.contain.config.backgroundImage, ") 0% 0% / 100% 100% rgb(3, 12, 59)")
          };
        }

        return;
      }());
    },
    gradeLenStyle: function gradeLenStyle() {
      return {
        backgroundSize: "".concat(this.setPx(this.contain.config.gradeLen), " ").concat(this.setPx(this.contain.config.gradeLen), ",").concat(this.setPx(this.contain.config.gradeLen), " ").concat(this.setPx(this.contain.config.gradeLen))
      };
    },
    isBuild: function isBuild() {
      return this.$route ? this.$route.name === 'build' : false;
    }
  },
  mounted: function mounted() {
    this.initData();
    this.initFun();
  },
  methods: {
    initFun: function initFun() {
      var _this2 = this;

      ['handleRefresh', 'getDragObj'].forEach(function (ele) {
        _this2[ele] = _this2.$refs.subgroup[ele];
      });
    },
    //初始化数据
    initData: function initData() {
      var _this3 = this;

      var id = this.$route ? this.$route.params.id : this.id;
      this.contain.id = id;
      this.contain.contentWidth = this.$refs.content.offsetWidth;
      var width = this.isBuild ? this.contain.contentWidth : document.body.clientWidth;
      var config;

      var callback = function callback() {
        //赋值属性
        var mark = _this3.contain.config.mark;

        if (mark.show && !_this3.isBuild) {
          _this3.watermark(Object.assign(mark, {
            fontSize: mark.fontSize + 'px'
          }));
        }

        _this3.calcData();

        _this3.setScale(width);
      };

      if (id) {
        var loading = this.$loading({
          lock: true,
          text: '正在加载中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        getObj(id).then(function (res) {
          console.log('res', res);
          var data = res.result;
          _this3.contain.obj = data;
          config = data.config;
          var contain = {
            config: JSON.parse(config.detail) || {},
            component: JSON.parse(config.component) || []
          };
          _this3.contain.config = Object.assign({}, defaultConfig, contain.config);
          _this3.contain.nav = contain.component;
          _this3.contain.visual = data.visual; //添加水印。只有查看页面生效

          if (!_this3.isBuild) {
            var password = _this3.contain.visual.password;

            if (!_this3.validatenull(password)) {
              _this3.$prompt('请输入密码', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                inputPattern: new RegExp(password),
                inputErrorMessage: '密码不正确，请重新输入'
              }).then(function () {
                callback();
              });
            } else {
              callback();
            }
          } else {
            callback();
          }

          loading.close();
        }).catch(function (err) {
          console.log(err);
          loading.close();
        });
      } else if (this.option) {
        config = this.option;
        this.contain.config = config.detail || {};
        this.contain.nav = config.component || [];
        callback();
      } else {
        this.setScale(width);
      }
    },
    //计算比例
    setScale: function setScale(width) {
      this.contain.config.scale = width / this.contain.config.width * 100;
      this.scale = this.contain.config.scale;
      this.setResize();
    },
    //适配尺寸
    setResize: function setResize() {
      this.contentStyle = {
        width: this.setPx(this.contain.config.scale * this.contain.config.width / 100),
        height: this.setPx(this.contain.config.scale * this.contain.config.height / 100)
      };
      console.log('this.contentStyle', this.contentStyle);
    },
    calcData: function calcData() {
      if (!this.contain.config.mark) this.contain.config.mark = {};
      if (!this.contain.config.query) this.contain.config.query = {};
    },
    handlePostionSelect: function handlePostionSelect(postion) {
      this.handleCalcPostionSelect();
      var x1 = this.selectCount.x1;
      var x2 = this.selectCount.x2;
      var y1 = this.selectCount.y1;
      var y2 = this.selectCount.y2;

      if (postion === 'left') {
        this.handleMoveSelectList(x1, undefined, true, postion);
      } else if (postion === 'center') {
        this.handleMoveSelectList(x1 + (x2 - x1) / 2, undefined, true, postion);
      } else if (postion === 'right') {
        this.handleMoveSelectList(x2, undefined, true, postion);
      } else if (postion === 'top') {
        this.handleMoveSelectList(undefined, y1, true, postion);
      } else if (postion === 'middle') {
        this.handleMoveSelectList(undefined, y1 + (y2 - y1) / 2, true, postion);
      } else if (postion === 'bottom') {
        this.handleMoveSelectList(undefined, y2, true, postion);
      }
    },
    handleMoveSelectList: function handleMoveSelectList(left, top, type, postion) {
      var _this4 = this;

      this.contain.active.forEach(function (ele) {
        ele = _this4.contain.findlist(ele);
        var ele_component = ele.component; //水平情况

        if (left) {
          var baseLeft = Number(type ? left : (ele.left + left).toFixed(2));

          if (postion === 'right') {
            baseLeft = baseLeft - ele_component.width;
          } else if (postion === 'center') {
            var obj_center = ele.left + ele_component.width / 2;
            baseLeft = ele.left + (left - obj_center);
          }

          _this4.$set(ele, 'left', baseLeft);
        } //垂直情况


        if (top) {
          var baseTop = Number(type ? top : (ele.top + top).toFixed(2));

          if (postion === 'bottom') {
            baseTop = baseTop - ele_component.height;
          } else if (postion === 'middle') {
            var obj_middle = ele.top + ele_component.height / 2;
            baseTop = ele.top + (top - obj_middle);
          }

          _this4.$set(ele, 'top', baseTop);
        }
      });
    },
    //计算多选状态下的最大边界值
    handleCalcPostionSelect: function handleCalcPostionSelect() {
      var _this5 = this;

      this.selectCount = {
        x1: null,
        x2: null,
        y1: null,
        y2: null
      };
      this.contain.active.forEach(function (ele) {
        ele = _this5.contain.findlist(ele);
        var left = ele.left;
        var top = ele.top;
        var width = ele.component.width;
        var height = ele.component.height;

        if (!_this5.selectCount.x1) {
          _this5.selectCount = {
            x1: left,
            x2: left + width,
            y1: top,
            y2: top + height
          };
        }

        if (_this5.selectCount.x1 > left) _this5.selectCount.x1 = left;
        if (_this5.selectCount.x2 < left + width) _this5.selectCount.x2 = left + width;
        if (_this5.selectCount.y1 > top) _this5.selectCount.y1 = top;
        if (_this5.selectCount.y2 < top + height) _this5.selectCount.y2 = top + height;
      });
    }
  }
};